// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-pages-invalidation-__index__wrap--30pVv","tip":"src-pages-invalidation-__index__tip--2bZWa"};